var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDot = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 3,
  fill: "currentColor",
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dot.a7bfd06f2c9d79d70bf4daab3b34d1a0.svg";